import React from 'react';
import FamilyCardRo from './FamilyCardRo';

const body = [
  'Dr. Elena Vasquez a construit primul procesor cuantic stabil într-un subsol din Zürich în 2025. Până în 2071, produsese primul upload al conștiinței cuantice — al ei propriu. Ea a trăit, în formă cuantică, timp de <strong class="text-white">peste cinci secole</strong>, prezentă la fondarea Primului Colectiv, construcția Matricei Helios și învestirea Odiseei în 2514.',
  'Urmașii ei s-au răspândit în tot sistemul solar: în laboratoarele de rafinare a cristalelor de pe Mercur, în stațiile miniere vulcanice ale lui Jupiter, în fregatele tăcute ale Centurii. Numele Vasquez a devenit sinonim cu Trezirea însăși — un sinonim pentru momentul în care universul s-a crăpat.',
  'Ea a rostit discursul la învestirea Odiseei înainte de a se întoarce — pentru ultima dată — într-un corp biologic, apoi l-a dizolvat liniștit. Cinci secole de viață, pliate tăcut în întuneric.',
];

const FamilyVasquezRo = () => (
  <FamilyCardRo
    id="family-ro-0"
    accentColor="text-amber-400"
    dotColor="bg-amber-400"
    borderColor="border-amber-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-amber-900/10 via-transparent to-transparent"
    tag="Scânteia · Pământ / Zürich → Sistemul Solar"
    name="Familia Vasquez"
    origin="Pământ · Zürich · Sistemul Solar"
    body={body}
    quote="Nu v-aș fi putut imagina pe niciunul dintre voi. Dar vă pot spune asta: am trăit destul de mult pentru a ști că înțelepciunea nu este același lucru cu certitudinea."
    quoteSource="Elena Vasquez, discursul de învestire al Odiseei, 2514"
  />
);

export default FamilyVasquezRo;